/**
 * Require all files from directory and export it as object
 */
import camelCase from "lodash.camelcase";
const requireModule = require.context(".", false, /\.vue$/); //extract vue files inside modules folder
const modules = {};

requireModule.keys().forEach(fileName => {
  if (fileName === "./index.js") return; //reject the index.js file

  const moduleName = camelCase(fileName.replace(/(\.\/|\.vue)/g, "")); //

  modules[moduleName] = requireModule(fileName).default;
});
export default modules;
